import { createFileRoute, redirect } from "@tanstack/react-router";

// People type /login out of habit; the sign-in page lives at /auth.
export const Route = createFileRoute("/login")({
  beforeLoad: ({ search }) => { throw redirect({ to: "/auth", search, replace: true }); },
});
